import { apiRequest } from './client';
import type { AdminAudit, AdminAction } from '@outlinked/shared';

// Re-export the canonical AdminAudit row shape so consumers continue to
// import from this file. `AuditItem` is a back-compat alias.
export type { AdminAudit, AdminAction };
export type AuditItem = AdminAudit;

export interface AuditListResponse {
  items: AdminAudit[];
  nextCursor?: string | null;
}

export function listAudit(opts: { date?: string } = {}): Promise<AuditListResponse> {
  const params = new URLSearchParams();
  if (opts.date) params.set('date', opts.date);
  return apiRequest<AuditListResponse>(`/audit?${params}`);
}
